import { styled } from '@mui/material/styles';
import TimeframePicker from '@components/TimeframePicker';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';

export { SplitModal as Modal, PreviewWrapper } from '@components/SplitModal';

export const FormWrapper = styled('div')({
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    '@media (max-width: 768px)': {
        overflowY: 'initial',
        overflowX: 'initial',
    },
});

export const Content = styled('div')({
    display: 'grid',
    gridGap: '8px 24px',
    gridTemplateColumns: '100%',
    overflowX: 'initial',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gridGap: '8px',
    },
});

export const StyledTimeframePicker = styled(TimeframePicker)({
    width: 'calc(50% - 4px)',
});

export const RadioButtonsWrapper = styled('div')({
    overflowX: 'auto',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
    '@media (max-width: 768px)': {
        overflowX: 'auto',
    },
});

export const StyledRadioButtons = styled(RadioButtonsGroup)({
    marginTop: '8px',
    marginBottom: '16px',
    width: 'max-content',
    '& .MuiFormControlLabel-root': {
        flex: 'initial',
    },
});

export const TypeContainer = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 4px) calc(25% - 16px) calc(25% - 16px)',
    gap: '16px',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '100%',
        gap: '8px',
    },
});
